<template>
  <div v-if="activado" style="height: 100%; display: flex; flex-direction: column; position: relative;">
    <div
      v-if="isdevmode"
      class="red white--text"
      style="width: 130px; z-index: 3; position: absolute; height: 18px; left: 0; font-size: 12px; line-height: 18px; text-align: center;">
      <b>MODO PRUEBAS</b>
    </div>

    <v-toolbar dense flat class="flex-shrink-0">
      <a :href="redirect" class="d-flex">
        <v-img
          :src="$store.state.unidad.logo"
          max-width="60"
          contain
          class="mr-2"
          style="cursor: pointer;" />
      </a>

      <v-spacer></v-spacer>

      <v-btn
        v-if="
          $store.state.CARGO &&
          ($store.state.CARGO.id == 1 ||
            $store.state.CARGO.id == 14 ||
            $store.state.CARGO.id == 15 ||
            $store.state.CARGO.id == 25)
        "
        tile
        color="purple"
        small
        dark
        class="mr-2"
        @click="openregistrarCaja()">
        <v-icon left>mdi-package-variant</v-icon> Caja
      </v-btn>

      <v-select 
        :items="convenios"
        v-model="$store.state.convenio"
        item-text="nombre"
        item-value="id"
        class="mt-0 pt-0 mr-2"
        style="min-width: 150px; max-width: 280px"
        label="Convenio:"
        outlined
        dense
        placeholder="Seleccione..."
        hide-details
        return-object
        v-if="
          $store.state.CARGO.sede.unidad_negocio == 1 || $store.state.CARGO.sede.unidad_negocio == 10
        "></v-select>

      <multiselect
        v-model="$store.state.CARGO"
        :options="$store.state.CARGOS"
        :disabled="!$store.state.show_rol_select"
        track-by="idsede"
        label="nombre"
        class="multiselect-custom mt-0 pt-0 mr-2"
        style="min-width: 220px; max-width: 250px;"
        :searchable="true"
        :close-on-select="true"
        :show-labels="false"
        :multiple="false"
        placeholder="Seleccione..." />

      <v-btn text small class="mx-1" @click="perfil">
        <v-icon left small>mdi-account</v-icon>
        <span class="body-2">{{ $store.state.DATA_USER.nombres }}</span>
        <span
          class="caption ml-1"
          :title="'total conexiones activas: '+$store.state.CONSWS.total_tabs">
          ({{ $store.state.CONSWS.total_users }})
        </span>
      </v-btn>

      <v-menu open-on-hover top offset-y>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            :loading="relogin_loading"
            color="primary"
            text
            dark
            v-bind="attrs"
            v-on="on"
            small>
            <v-icon left small>mdi-logout</v-icon>
            Menu
          </v-btn>
        </template>

        <v-card class="mx-auto" max-width="344" outlined>
          <v-list-item three-line>
            <v-list-item-content>
              <div class="text-overline mb-4">Menu</div>
              <v-list-item-title class="text-h5 mb-1">
                {{ $store.state.DATA_USER.nombres }}
              </v-list-item-title>
              <v-list-item-subtitle>Sin comentarios :)</v-list-item-subtitle>
            </v-list-item-content>
            <v-list-item-avatar tile size="80" color="grey"></v-list-item-avatar>
          </v-list-item>

          <v-card-actions>
            <v-btn outlined color="red" text @click="salir"> Salir </v-btn>
            <v-btn outlined color="green" text @click="relogin"> Re login </v-btn>
          </v-card-actions>
        </v-card>
      </v-menu>
    </v-toolbar>

    <v-divider></v-divider>

    <div style="display: flex; flex: 1; overflow: hidden;">
      <v-navigation-drawer
        v-model="drawer"
        :mini-variant.sync="mini"
        permanent
        width="260"
        mini-variant-width="56"
        class="sidebar-drawer"
        style="overflow-y: auto;">

        <template v-slot:prepend>
          <div class="text-center" style="padding: 6px 0;">
            <v-avatar :size="mini ? 40 : 56" class="d-block mx-auto my-1" @click="toggleMini" style="cursor: pointer;">
              <v-img :src="profile" alt="PERFIL" />
            </v-avatar>
            <div class="body-2 font-weight-bold primary--text text-truncate px-1" :class="mini ? 'd-none' : ''">
              {{ $store.state.DATA_USER.nombres }}
              {{ $store.state.DATA_USER.pri_apellido }}
            </div>
          </div>
          <v-divider></v-divider>
        </template>

        <v-list dense nav class="py-0">
          <v-list-group
            v-if="$store.state.CARGO?.id != 27"
            prepend-icon="mdi-cog"
            no-action>
            <template v-slot:activator>
              <v-list-item-title>Feria</v-list-item-title>
            </template>
            <v-list-item to="/contactosferia" link>
              <v-list-item-icon><v-icon>mdi-account-multiple</v-icon></v-list-item-icon>
              <v-list-item-title>Contactos</v-list-item-title>
            </v-list-item>
            <v-list-item
              to="/insferia"
              link
              v-if="
                $store.state.CARGO?.id == 1 || $store.state.DATA_USER.id == 14401 || $store.state.DATA_USER.id == 75939
              ">
              <v-list-item-icon><v-icon>mdi-file-document-multiple</v-icon></v-list-item-icon>
              <v-list-item-title>Inscripciones</v-list-item-title>
            </v-list-item>
          </v-list-group>

          <template v-for="menu in $store.state.MENUS">
            <v-list-group
              v-if="menu.nombre == 'Cargos'"
              :key="menu.id"
              prepend-icon="mdi-cog"
              no-action>
              <template v-slot:activator>
                <v-list-item-title>Sistema</v-list-item-title>
              </template>
              <v-list-item
                to="/cargos"
                link
                v-if="$store.state.CARGO.id == 1 || $store.state.CARGO.id == 2 || $store.state.CARGO.id == 8 || $store.state.CARGO.id == 3 || is_rol_administrador">
                <v-list-item-icon><v-icon>mdi-account-tie</v-icon></v-list-item-icon>
                <v-list-item-title>Cargos</v-list-item-title>
              </v-list-item>
              <v-list-item to="/sedes" link>
                <v-list-item-icon><v-icon>mdi-domain</v-icon></v-list-item-icon>
                <v-list-item-title>Sedes</v-list-item-title>
              </v-list-item>
              <v-list-item
                to="/usuarios"
                link
                v-if="$store.state.CARGO.id != 13 && $store.state.CARGO.id != 12">
                <v-list-item-icon><v-icon>mdi-account-group</v-icon></v-list-item-icon>
                <v-list-item-title>Usuarios</v-list-item-title>
              </v-list-item>
              <v-list-item
                to="/unidades"
                link
                v-if="$store.state.CARGO.id == 1 || $store.state.CARGO.id == 8 || $store.state.DATA_USER.id == 9029">
                <v-list-item-icon><v-icon>mdi-office-building</v-icon></v-list-item-icon>
                <v-list-item-title>Unidades</v-list-item-title>
              </v-list-item>
              <v-list-item
                to="/datosfacturaele"
                link
                v-if="
                  $store.state.CARGO.id == 1 ||
                  $store.state.CARGO.id == 14 ||
                  $store.state.CARGO.id == 15 ||
                  $store.state.CARGO.id == 25 ||
                  $store.state.DATA_USER.id == 9029
                ">
                <v-list-item-icon><v-icon>mdi-file-document-edit</v-icon></v-list-item-icon>
                <v-list-item-title><small>Factura config.</small></v-list-item-title>
              </v-list-item>
              <v-list-item
                to="/nominaciones"
                link
                v-if="$store.state.CARGO.id == 1 || is_rol_administrador">
                <v-list-item-icon><v-icon>mdi-format-list-bulleted</v-icon></v-list-item-icon>
                <v-list-item-title>Nominaciones</v-list-item-title>
              </v-list-item>
              <v-list-item
                to="/excelins"
                link
                v-if="$store.state.CARGO.id == 1 || is_rol_administrador">
                <v-list-item-icon><v-icon>mdi-file-excel</v-icon></v-list-item-icon>
                <v-list-item-title>Est. Excel</v-list-item-title>
              </v-list-item>
            </v-list-group>

            <v-list-group
              v-else-if="menu.nombre == 'Mis inscripciones'"
              :key="menu.id || 1"
              prepend-icon="mdi-bullhorn"
              no-action>
              <template v-slot:activator>
                <v-list-item-title>Marketing</v-list-item-title>
              </template>
              <v-list-item
                to="/prospectos1"
                link
                v-if="$store.state.CARGO.sede.unidad_negocio == 1 || $store.state.CARGO.sede.unidad_negocio == 5">
                <v-list-item-icon><v-icon>mdi-account-multiple</v-icon></v-list-item-icon>
                <v-list-item-title>Contactos MKT</v-list-item-title>
              </v-list-item>
              <v-list-item
                to="/misinscripciones"
                link
                v-if="$store.state.CARGO.sede.unidad_negocio != 1 && $store.state.CARGO.sede.unidad_negocio != 5">
                <v-list-item-icon><v-icon>mdi-format-list-bulleted</v-icon></v-list-item-icon>
                <v-list-item-title>Inscripciones</v-list-item-title>
              </v-list-item>
              <v-list-item
                to="/contactos"
                link
                v-if="$store.state.CARGO.sede.unidad_negocio != 1 && $store.state.CARGO.sede.unidad_negocio != 5">
                <v-list-item-icon><v-icon>mdi-database</v-icon></v-list-item-icon>
                <v-list-item-title>Base de datos</v-list-item-title>
              </v-list-item>
              <v-list-item @click="irAWebinars()" link style="border-bottom: 1px solid #999999;">
                <v-list-item-icon><v-icon>mdi-video</v-icon></v-list-item-icon>
                <v-list-item-title>Webinars</v-list-item-title>
              </v-list-item>
              <v-list-item @click="irAWapito()" link style="border-bottom: 1px solid #999999;">
                <v-list-item-icon><v-icon>mdi-whatsapp</v-icon></v-list-item-icon>
                <v-list-item-title>Wapito</v-list-item-title>
              </v-list-item>
            </v-list-group>

            <v-list-group
              v-else-if="menu.nombre == 'Postgrados'"
              :key="menu.id || 2"
              prepend-icon="mdi-school"
              no-action>
              <template v-slot:activator>
                <v-list-item-title>Academico</v-list-item-title>
              </template>

              <v-list-item
                to="/oferta_academica"
                link
                v-if="veroferta">
                <v-list-item-icon><v-icon>mdi-book-open-variant</v-icon></v-list-item-icon>
                <v-list-item-title>Oferta Acad.</v-list-item-title>
              </v-list-item>

              <v-list-item
                to="/postgrados"
                link
                v-if="
                  ($store.state.DATA_USER.id == 3506 ||
                  ($store.state.CARGO.id != 11 &&
                    $store.state.CARGO.id != 12 &&
                    $store.state.CARGO.id != 13 &&
                    $store.state.CARGO.id != 14 &&
                    $store.state.CARGO.id != 24 &&
                    $store.state.CARGO.id != 15 &&
                    $store.state.CARGO.id != 25)) && $store.state.CARGO.sede.unidad_negocio != -10
                ">
                <v-list-item-icon><v-icon>mdi-bookmark</v-icon></v-list-item-icon>
                <v-list-item-title>{{ $store.state.unidad.postgrados }}</v-list-item-title>
              </v-list-item>

              <v-list-item to="/programas" link>
                <v-list-item-icon><v-icon>mdi-book</v-icon></v-list-item-icon>
                <v-list-item-title>{{ $store.state.unidad.programas }}</v-list-item-title>
              </v-list-item>

              <v-list-group
                sub-group
                no-action
                v-if="permisosResponsablesAdmisiones || permisosResponsablesTitulaciones || permisosDNA">
                <template v-slot:activator>
                  <v-list-item-title>Opciones de Documentos</v-list-item-title>
                </template>
                <v-list-item :to="{ name: 'documentos-inscripciones' }" link>
                  <v-list-item-icon><v-icon>mdi-file-document</v-icon></v-list-item-icon>
                  <v-list-item-title>Doc. Inscrip.</v-list-item-title>
                </v-list-item>
                <v-list-item :to="{ name: 'documentos-por-programa' }" link>
                  <v-list-item-icon><v-icon>mdi-file-document-multiple</v-icon></v-list-item-icon>
                  <v-list-item-title>Por Programa</v-list-item-title>
                </v-list-item>
              </v-list-group>

              <v-list-item
                to="/personas"
                link
                v-if="$store.state.CARGO.id != 24">
                <v-list-item-icon><v-icon>mdi-account</v-icon></v-list-item-icon>
                <v-list-item-title>Personas</v-list-item-title>
              </v-list-item>

              <v-list-item
                to="/menureportetitulaciones"
                link
                v-if="
                  $store.state.CARGO.id == 6 ||
                  $store.state.CARGO.id == 5 ||
                  $store.state.CARGO.id == 17 ||
                  $store.state.CARGO.id == 1 ||
                  $store.state.DATA_USER.id == 9029
                ">
                <v-list-item-icon><v-icon>mdi-chart-bar</v-icon></v-list-item-icon>
                <v-list-item-title>Reporte Titls.</v-list-item-title>
              </v-list-item>

              <v-list-item
                to="/migracionacademico"
                link
                v-if="$store.state.CARGO.id != 3 && $store.state.CARGO.id != 26 && $store.state.CARGO.id != 27">
                <v-list-item-icon><v-icon>mdi-database-sync</v-icon></v-list-item-icon>
                <v-list-item-title>Migracion Academico</v-list-item-title>
              </v-list-item>

              <v-list-item
                to="/solicitudesuniversidadcertificados"
                link
                v-if="$store.state.CARGO.id == 1 || $store.state.CARGO.id == 26 || $store.state.CARGO.id == 4">
                <v-list-item-icon><v-icon>mdi-file-certificate</v-icon></v-list-item-icon>
                <v-list-item-title>Sol Certificados Universidad</v-list-item-title>
              </v-list-item>

              <v-list-item
                to="/programasuniversidadcertificados"
                link
                v-if="$store.state.CARGO.id == 1 || $store.state.CARGO.id == 26 || $store.state.CARGO.id == 4">
                <v-list-item-icon><v-icon>mdi-certificate</v-icon></v-list-item-icon>
                <v-list-item-title>Certificaciones Univ</v-list-item-title>
              </v-list-item>

              <v-list-item
                to="/plataformas"
                link
                v-if="$store.state.CARGO.id == 8 || $store.state.CARGO.id == 1 || $store.state.DATA_USER.id == 9029">
                <v-list-item-icon><v-icon>mdi-cloud</v-icon></v-list-item-icon>
                <v-list-item-title>Plataformas</v-list-item-title>
              </v-list-item>

              <v-list-item @click="irPortal2()" link style="border-bottom: 1px solid #999999;">
                <v-list-item-icon><v-icon>mdi-briefcase</v-icon></v-list-item-icon>
                <v-list-item-title>Proyectos</v-list-item-title>
              </v-list-item>

              <v-list-group sub-group no-action>
                <template v-slot:activator>
                  <v-list-item-title>Calificaciones</v-list-item-title>
                </template>
                <v-list-item
                  to="/solicitud-modificaciones-calificaciones"
                  link>
                  <v-list-item-icon><v-icon>mdi-file-edit</v-icon></v-list-item-icon>
                  <v-list-item-title>Solicitud</v-list-item-title>
                </v-list-item>
                <v-list-item
                  :to="{ name: 'calificaciones-centralizador' }"
                  link>
                  <v-list-item-icon><v-icon>mdi-format-list-bulleted</v-icon></v-list-item-icon>
                  <v-list-item-title>Centralizador</v-list-item-title>
                </v-list-item>
              </v-list-group>
            </v-list-group>

            <template v-else-if="menu.nombre == 'Facturas' && ($store.state.CARGO.id == 13 || $store.state.CARGO.id == 12)"></template>

            <v-list-group
              v-else-if="menu.nombre == 'Facturas'"
              :key="menu.id || 3"
              prepend-icon="mdi-credit-card"
              no-action>
              <template v-slot:activator>
                <v-list-item-title>Contabilidad</v-list-item-title>
              </template>

              <v-list-item
                to="/recibos"
                link
                v-if="$store.state.CARGO.sede.id != 19 && $store.state.CARGO.id != 3">
                <v-list-item-icon><v-icon>mdi-receipt</v-icon></v-list-item-icon>
                <v-list-item-title>Pagos</v-list-item-title>
              </v-list-item>

              <v-list-item
                to="/cajas"
                link
                v-if="
                  $store.state.CARGO.id == 1 ||
                  $store.state.CARGO.id == 14 ||
                  $store.state.CARGO.id == 15 ||
                  $store.state.CARGO.id == 25 || is_rol_administrador
                ">
                <v-list-item-icon><v-icon>mdi-package-variant</v-icon></v-list-item-icon>
                <v-list-item-title>Mis Cajas</v-list-item-title>
              </v-list-item>

              <v-list-item
                to="/depositosede"
                link
                v-if="
                  $store.state.CARGO.id == 1 ||
                  $store.state.CARGO.id == 14 ||
                  $store.state.CARGO.id == 15 ||
                  $store.state.CARGO.id == 25 || is_rol_administrador
                ">
                <v-list-item-icon><v-icon>mdi-bank</v-icon></v-list-item-icon>
                <v-list-item-title>Depositos Caja</v-list-item-title>
              </v-list-item>

              <v-list-item to="/pre_registros_mkt" link v-show="false">
                <v-list-item-icon><v-icon>mdi-account-multiple</v-icon></v-list-item-icon>
                <v-list-item-title>Registros MKT</v-list-item-title>
              </v-list-item>

              <v-list-item
                to="/facturascv"
                link
                v-if="
                  $store.state.CARGO.id == 14 ||
                  $store.state.CARGO.id == 15 ||
                  $store.state.CARGO.id == 25 ||
                  $store.state.CARGO.id == 27 ||
                  $store.state.CARGO.id == 1 || is_rol_administrador
                ">
                <v-list-item-icon><v-icon>mdi-file-document</v-icon></v-list-item-icon>
                <v-list-item-title>Facturas C-V</v-list-item-title>
              </v-list-item>

              <v-list-item
                to="/facturased"
                link
                v-if="
                  $store.state.CARGO.id == 14 ||
                  $store.state.CARGO.id == 15 ||
                  $store.state.CARGO.id == 25 ||
                  $store.state.CARGO.id == 27 ||
                  $store.state.CARGO.id == 1 || is_rol_administrador
                ">
                <v-list-item-icon><v-icon>mdi-school</v-icon></v-list-item-icon>
                <v-list-item-title>Facturas S-E</v-list-item-title>
              </v-list-item>

              <v-list-item to="/notasdc" link v-if="$store.state.CARGO.id == 310 || is_rol_administrador">
                <v-list-item-icon><v-icon>mdi-swap-horizontal</v-icon></v-list-item-icon>
                <v-list-item-title>Notas D-C</v-list-item-title>
              </v-list-item>

              <v-list-item
                to="/consolidarfact"
                link
                v-if="$store.state.CARGO.id != 3 && $store.state.CARGO.id != 26 && $store.state.CARGO.id != 27 || is_rol_administrador">
                <v-list-item-icon><v-icon>mdi-call-merge</v-icon></v-list-item-icon>
                <v-list-item-title>Consolidar F.</v-list-item-title>
              </v-list-item>

              <v-list-item
                to="/facturaslista"
                link
                v-if="$store.state.CARGO.id != 3 && $store.state.CARGO.id != 26 && $store.state.CARGO.id != 27 || is_rol_administrador">
                <v-list-item-icon><v-icon>mdi-format-list-bulleted</v-icon></v-list-item-icon>
                <v-list-item-title>Facturas</v-list-item-title>
              </v-list-item>

              <v-list-item
                to="/facturaslistaext"
                link
                v-if="
                  $store.state.DATA_USER.id == 31 ||
                  $store.state.DATA_USER.id == 6457 ||
                  $store.state.CARGO.id == 18 ||
                  $store.state.CARGO.id == 1 || is_rol_administrador
                ">
                <v-list-item-icon><v-icon>mdi-file-document-outline</v-icon></v-list-item-icon>
                <v-list-item-title>Facturas Nal.</v-list-item-title>
              </v-list-item>

              <v-list-item
                to="/descuentoslista"
                link
                v-if="
                  $store.state.CARGO.id == 19 ||
                  $store.state.CARGO.id == 14 ||
                  $store.state.CARGO.id == 15 ||
                  $store.state.CARGO.id == 25 ||
                  $store.state.CARGO.id == 1 || is_rol_administrador
                ">
                <v-list-item-icon><v-icon>mdi-percent</v-icon></v-list-item-icon>
                <v-list-item-title>Descuentos</v-list-item-title>
              </v-list-item>

              <v-list-item
                to="/motivos-descuento"
                link
                v-if="$store.state.CARGO.id == 19 || $store.state.CARGO.id == 14 || $store.state.CARGO.id == 1 || is_rol_administrador">
                <v-list-item-icon><v-icon>mdi-comment-question</v-icon></v-list-item-icon>
                <v-list-item-title>Motivos Des.</v-list-item-title>
              </v-list-item>

              <v-list-item
                to="/asignacionesmenu"
                link
                v-if="
                  $store.state.CARGO.id == 19 ||
                  $store.state.CARGO.id == 14 ||
                  $store.state.CARGO.id == 15 ||
                  $store.state.CARGO.id == 25 ||
                  $store.state.CARGO.id == 1 ||
                  $store.state.CARGO.id == 3 ||
                  $store.state.CARGO.id == 17 ||
                  $store.state.CARGO.id == 26 ||
                  $store.state.CARGO.id == 22 || is_rol_administrador
                ">
                <v-list-item-icon><v-icon>mdi-format-list-checks</v-icon></v-list-item-icon>
                <v-list-item-title>Asignaciones</v-list-item-title>
              </v-list-item>

              <v-list-item
                to="/contratoslista"
                link
                v-if="
                  $store.state.CARGO.id == 19 ||
                  $store.state.CARGO.id == 14 ||
                  $store.state.CARGO.id == 15 ||
                  $store.state.CARGO.id == 25 ||
                  $store.state.CARGO.id == 1 || is_rol_administrador
                ">
                <v-list-item-icon><v-icon>mdi-file-sign</v-icon></v-list-item-icon>
                <v-list-item-title>Ver Contratos</v-list-item-title>
              </v-list-item>

              <v-list-item
                to="/promociones"
                link
                v-if="$store.state.CARGO.id == 1 || $store.state.CARGO.id == 14 || is_rol_administrador">
                <v-list-item-icon><v-icon>mdi-tag</v-icon></v-list-item-icon>
                <v-list-item-title>Promociones</v-list-item-title>
              </v-list-item>

              <v-list-item
                to="/promociones-v2"
                link
                v-if="$store.state.CARGO.id == 1 || $store.state.CARGO.id == 14 || is_rol_administrador">
                <v-list-item-icon><v-icon>mdi-tag-multiple</v-icon></v-list-item-icon>
                <v-list-item-title>Promociones v2</v-list-item-title>
              </v-list-item>

              <v-list-item
                to="/promociones-v3"
                link
                v-if="$store.state.CARGO.id == 1 || $store.state.CARGO.id == 14 || is_rol_administrador || $store.state.DATA_USER.id == 94366">
                <v-list-item-icon><v-icon>mdi-tag-heart</v-icon></v-list-item-icon>
                <v-list-item-title>Promociones v3</v-list-item-title>
              </v-list-item>

              <v-list-item
                to="/pagos_templates"
                link
                v-if="$store.state.CARGO.id == 1 || $store.state.CARGO.id == 14 || is_rol_administrador">
                <v-list-item-icon><v-icon>mdi-calendar-text</v-icon></v-list-item-icon>
                <v-list-item-title>Prog. pagos</v-list-item-title>
              </v-list-item>

              <v-list-item
                to="/AntiguosRecibos"
                link
                v-if="
                  (!$store.state.isonlyread &&
                  $store.state.CARGO.id != 3 &&
                  $store.state.CARGO.id != 26 &&
                  $store.state.CARGO.id != 27) || is_rol_administrador
                ">
                <v-list-item-icon><v-icon>mdi-history</v-icon></v-list-item-icon>
                <v-list-item-title>Rec. Antiguos</v-list-item-title>
              </v-list-item>
            </v-list-group>

            <v-list-group
              v-else-if="menu.nombre == 'Planificador' && ($store.state.CARGO.id == 1 || $store.state.CARGO.id == 22 || $store.state.CARGO.id == 26 || is_rol_administrador)"
              :key="menu.id || 4"
              prepend-icon="mdi-chart-line"
              no-action>
              <template v-slot:activator>
                <v-list-item-title>Planificador</v-list-item-title>
              </template>

              <v-list-item to="/oferta_acadenika" link>
                <v-list-item-icon><v-icon>mdi-book-open-variant</v-icon></v-list-item-icon>
                <v-list-item-title>Oferta A.</v-list-item-title>
              </v-list-item>
              <v-list-item to="/xreporteporsede" link>
                <v-list-item-icon><v-icon>mdi-chart-bar</v-icon></v-list-item-icon>
                <v-list-item-title>Reporte MKT2.</v-list-item-title>
              </v-list-item>
              <v-list-item
                to="/menureportetitulaciones"
                link
                v-if="$store.state.CARGO.id == 1 || $store.state.CARGO.id == 22 || is_rol_administrador">
                <v-list-item-icon><v-icon>mdi-file-report</v-icon></v-list-item-icon>
                <v-list-item-title>Reporte Titulaciones</v-list-item-title>
              </v-list-item>
            </v-list-group>

            <v-list-group
              v-else-if="menu.nombre == 'Presupuesto'"
              :key="menu.id || 5"
              prepend-icon="mdi-chart-line"
              no-action>
              <template v-slot:activator>
                <v-list-item-title>Presupuesto</v-list-item-title>
              </template>

              <v-list-group
                sub-group
                no-action
                v-if="permisosPresupuestos1 || permisosPresupuestos2 || permisosPresupuestos3 || is_rol_administrador">
                <template v-slot:activator>
                  <v-list-item-title>Opciones de Presupuestos</v-list-item-title>
                </template>
                <v-list-item
                  to="/presupuestos"
                  link
                  v-if="permisosPresupuestos1 || permisosPresupuestos2 || permisosPresupuestos3 || is_rol_administrador">
                  <v-list-item-icon><v-icon>mdi-currency-usd</v-icon></v-list-item-icon>
                  <v-list-item-title>Presupuestos (Gastos / Ingresos)</v-list-item-title>
                </v-list-item>
                <v-list-item
                  to="/presupuestos-consolidados"
                  link
                  v-if="permisosPresupuestos2 || permisosPresupuestos3 || is_rol_administrador">
                  <v-list-item-icon><v-icon>mdi-call-merge</v-icon></v-list-item-icon>
                  <v-list-item-title>Presupuestos Consolidados (Gastos / Ingresos)</v-list-item-title>
                </v-list-item>
                <v-list-item
                  to="/presupuestos-ingresos-estimaciones"
                  link
                  v-if="permisosPresupuestos1 || permisosPresupuestos2 || permisosPresupuestos3 || is_rol_administrador">
                  <v-list-item-icon><v-icon>mdi-chart-bell-curve</v-icon></v-list-item-icon>
                  <v-list-item-title>Presupuesto de Ingresos Estimados</v-list-item-title>
                </v-list-item>
                <v-list-item
                  to="/presupuestos-ingresos-proyectados"
                  link
                  v-if="permisosPresupuestos1 || permisosPresupuestos2 || permisosPresupuestos3 || is_rol_administrador">
                  <v-list-item-icon><v-icon>mdi-chart-line</v-icon></v-list-item-icon>
                  <v-list-item-title>Ingresos Proyectados Gestion Anterior</v-list-item-title>
                </v-list-item>
                <v-list-item
                  to="/presupuestos-ingresos-reportes"
                  link
                  v-if="permisosPresupuestos1 || permisosPresupuestos2 || permisosPresupuestos3 || is_rol_administrador">
                  <v-list-item-icon><v-icon>mdi-file-chart</v-icon></v-list-item-icon>
                  <v-list-item-title>Presupuesto de Ingresos Reportes</v-list-item-title>
                </v-list-item>
              </v-list-group>
            </v-list-group>

            <v-list-group
              v-else-if="menu.nombre == 'Tesorería'"
              :key="menu.id || 6"
              prepend-icon="mdi-inbox"
              no-action>
              <template v-slot:activator>
                <v-list-item-title>Tesorería</v-list-item-title>
              </template>

              <v-list-group
                sub-group
                no-action
                v-if="permisosPresupuestos1 || permisosPresupuestos2 || permisosPresupuestos3 || is_rol_administrador">
                <template v-slot:activator>
                  <v-list-item-title>Solicitud Recursos</v-list-item-title>
                </template>
                <v-list-item
                  to="/presupuestos-solicitud-transferencia-recursos"
                  link
                  v-if="permisosPresupuestos1 || permisosPresupuestos2 || permisosPresupuestos3 || is_rol_administrador">
                  <v-list-item-icon><v-icon>mdi-swap-horizontal-bold</v-icon></v-list-item-icon>
                  <v-list-item-title>Solicitud de Trans. Recursos</v-list-item-title>
                </v-list-item>
                <v-list-item
                  to="/presupuestos-transferencia-entre-sedes"
                  link
                  v-if="permisosPresupuestos2 || is_rol_administrador">
                  <v-list-item-icon><v-icon>mdi-domain-switch</v-icon></v-list-item-icon>
                  <v-list-item-title>Solicitud de Trans. Entre Sedes y Otros</v-list-item-title>
                </v-list-item>
                <v-list-item
                  to="/presupuestos-transferencia-entre-sedes-desembolsadas"
                  link
                  v-if="permisosPresupuestos1 || permisosPresupuestos2 || permisosPresupuestos3 || is_rol_administrador">
                  <v-list-item-icon><v-icon>mdi-check-all</v-icon></v-list-item-icon>
                  <v-list-item-title>Solicitud de Trans. Entre Sedes y Otros Desembolsadas</v-list-item-title>
                </v-list-item>
                <v-list-item
                  :to="{name: 'presupuestos-solicitudes-reversibles'}"
                  link
                  v-if="permisosPresupuestos2 || permisosPresupuestos3 || is_rol_administrador">
                  <v-list-item-icon><v-icon>mdi-restore</v-icon></v-list-item-icon>
                  <v-list-item-title>Solicitudes Reversibles</v-list-item-title>
                </v-list-item>
                <v-list-item
                  :to="{ name: 'presupuestos-solicitudes-reversion' }"
                  link
                  v-if="permisosPresupuestos1 || permisosPresupuestos2 || permisosPresupuestos3 || is_rol_administrador">
                  <v-list-item-icon><v-icon>mdi-undo</v-icon></v-list-item-icon>
                  <v-list-item-title>Solicitudes Reversión</v-list-item-title>
                </v-list-item>
                <v-list-item
                  to="/presupuestos-ejecucion-de-recursos"
                  link
                  v-if="permisosPresupuestos2 || permisosPresupuestos3 || is_rol_administrador">
                  <v-list-item-icon><v-icon>mdi-play-circle</v-icon></v-list-item-icon>
                  <v-list-item-title>Ejecución de Recursos</v-list-item-title>
                </v-list-item>
                <v-list-item
                  to="/presupuestos-reporte-desembolsos-por-item"
                  link
                  v-if="permisosPresupuestos2 || permisosPresupuestos3 || is_rol_administrador">
                  <v-list-item-icon><v-icon>mdi-file-report</v-icon></v-list-item-icon>
                  <v-list-item-title>Reporte de Desembolsos</v-list-item-title>
                </v-list-item>
              </v-list-group>

              <v-list-group
                sub-group
                no-action
                v-if="permisosPresupuestos2 || is_rol_administrador">
                <template v-slot:activator>
                  <v-list-item-title>Configuraciones</v-list-item-title>
                </template>
                <v-list-item
                  to="/presupuestos-configuraciones-generales"
                  link
                  v-if="permisosPresupuestos2 || is_rol_administrador">
                  <v-list-item-icon><v-icon>mdi-cog</v-icon></v-list-item-icon>
                  <v-list-item-title>Generales</v-list-item-title>
                </v-list-item>
                <v-list-item
                  to="/presupuestos-gestiones"
                  link
                  v-if="permisosPresupuestos2 || is_rol_administrador">
                  <v-list-item-icon><v-icon>mdi-calendar</v-icon></v-list-item-icon>
                  <v-list-item-title>Gestiones</v-list-item-title>
                </v-list-item>
                <v-list-item
                  to="/presupuestos-clasificadores"
                  link
                  v-if="permisosPresupuestos2 || is_rol_administrador">
                  <v-list-item-icon><v-icon>mdi-tag</v-icon></v-list-item-icon>
                  <v-list-item-title>Clasificadores</v-list-item-title>
                </v-list-item>
                <v-list-item
                  to="/presupuestos-grupos"
                  link
                  v-if="permisosPresupuestos2 || is_rol_administrador">
                  <v-list-item-icon><v-icon>mdi-account-group</v-icon></v-list-item-icon>
                  <v-list-item-title>Grupos</v-list-item-title>
                </v-list-item>
                <v-list-item
                  to="/presupuestos-cuentas-pagadoras"
                  link
                  v-if="permisosPresupuestos2 || is_rol_administrador">
                  <v-list-item-icon><v-icon>mdi-bank</v-icon></v-list-item-icon>
                  <v-list-item-title>Ctas. Pagadoras</v-list-item-title>
                </v-list-item>
                <v-list-item
                  to="/presupuestos-unidades-medida"
                  link
                  v-if="permisosPresupuestos2 || is_rol_administrador">
                  <v-list-item-icon><v-icon>mdi-ruler</v-icon></v-list-item-icon>
                  <v-list-item-title>Uds. Medida</v-list-item-title>
                </v-list-item>
                <v-list-item
                  to="/presupuestos-sedes"
                  link
                  v-if="permisosPresupuestos2 || is_rol_administrador">
                  <v-list-item-icon><v-icon>mdi-domain</v-icon></v-list-item-icon>
                  <v-list-item-title>Sedes</v-list-item-title>
                </v-list-item>
              </v-list-group>
            </v-list-group>

            <v-list-group
              v-else-if="menu.nombre == 'Pago'"
              :key="menu.id || 7"
              prepend-icon="mdi-tag"
              no-action>
              <template v-slot:activator>
                <v-list-item-title>Pago</v-list-item-title>
              </template>

              <v-list-item
                to="/pagos-programas"
                link
                v-if="permisosAcademicosSede || permisosAcademicosNacional || is_rol_administrador || permisosAcademicosSedeSoloLectura">
                <v-list-item-icon><v-icon>mdi-book</v-icon></v-list-item-icon>
                <v-list-item-title>Programas</v-list-item-title>
              </v-list-item>

              <v-list-item
                to="/pagos-sede-universidad"
                link
                v-if="permisosAcademicosNacional || is_rol_administrador">
                <v-list-item-icon><v-icon>mdi-domain</v-icon></v-list-item-icon>
                <v-list-item-title>Sedes Universidades</v-list-item-title>
              </v-list-item>

              <v-list-item
                to="/pagos-programa-universidad-sede"
                link
                v-if="permisosAcademicosSede || permisosPresupuestos1 || is_rol_administrador || permisosAcademicosSedeSoloLectura">
                <v-list-item-icon><v-icon>mdi-school</v-icon></v-list-item-icon>
                <v-list-item-title>Programas Universidades (Sedes)</v-list-item-title>
              </v-list-item>

              <v-list-item
                to="/pagos-programa-universidad-nacional"
                link
                v-if="permisosAcademicosNacional || permisosGestionEmpresarial || permisosContabilidadNacional || is_rol_administrador">
                <v-list-item-icon><v-icon>mdi-flag</v-icon></v-list-item-icon>
                <v-list-item-title>Programas Universidades (Nacional)</v-list-item-title>
              </v-list-item>

              <v-list-item
                to="/pagos-solicitudes-inscripciones"
                link
                v-if="permisosAcademicosNacional || permisosGestionEmpresarial || is_rol_administrador">
                <v-list-item-icon><v-icon>mdi-format-list-bulleted</v-icon></v-list-item-icon>
                <v-list-item-title>Solicitudes Inscripciones</v-list-item-title>
              </v-list-item>

              <v-list-item
                to="/pagos-solicitudes"
                link
                v-if="permisosPresupuestos2 || permisosAcademicosNacional || permisosGestionEmpresarial || permisosContabilidadNacional || is_rol_administrador">
                <v-list-item-icon><v-icon>mdi-file-document</v-icon></v-list-item-icon>
                <v-list-item-title>Solicitudes Pagos</v-list-item-title>
              </v-list-item>

              <v-list-item
                to="/pagos-solicitudes-agrupados"
                link
                v-if="
                  permisosAcademicosNacional ||
                  permisosPresupuestos2 ||
                  permisosGestionEmpresarial ||
                  permisosContabilidadNacional || is_rol_administrador
                ">
                <v-list-item-icon><v-icon>mdi-call-merge</v-icon></v-list-item-icon>
                <v-list-item-title>Solicitudes Pagos Agrupados</v-list-item-title>
              </v-list-item>

              <v-list-item
                to="/pagos-inscripciones-programas-universidad"
                link
                v-if="permisosAcademicosNacional || permisosGestionEmpresarial">
                <v-list-item-icon><v-icon>mdi-account-school</v-icon></v-list-item-icon>
                <v-list-item-title>Inscripciones Progr. Univ.</v-list-item-title>
              </v-list-item>

              <v-list-group
                sub-group
                no-action
                v-if="permisosAcademicosNacional || permisosPresupuestos2 || permisosContabilidadNacional || is_rol_administrador">
                <template v-slot:activator>
                  <v-list-item-title>Configuraciones</v-list-item-title>
                </template>
                <v-list-item
                  to="/pagos-conceptos"
                  link
                  v-if="permisosAcademicosNacional || permisosPresupuestos2 || permisosContabilidadNacional || is_rol_administrador">
                  <v-list-item-icon><v-icon>mdi-tag-text</v-icon></v-list-item-icon>
                  <v-list-item-title>Conceptos</v-list-item-title>
                </v-list-item>
                <v-list-item
                  to="/pagos-instituciones"
                  link
                  v-if="permisosAcademicosNacional || permisosPresupuestos2 || permisosContabilidadNacional || is_rol_administrador">
                  <v-list-item-icon><v-icon>mdi-domain</v-icon></v-list-item-icon>
                  <v-list-item-title>Instituciones</v-list-item-title>
                </v-list-item>
              </v-list-group>
            </v-list-group>

            <v-list-group
              v-else-if="menu.nombre == 'Comision'"
              :key="menu.id || 8"
              prepend-icon="mdi-currency-usd"
              no-action>
              <template v-slot:activator>
                <v-list-item-title>Comision</v-list-item-title>
              </template>

              <v-list-item
                to="/comisiones-sedes"
                link
                v-if="(!permisosInternacionalizacion && !permisosDNA) || permisosPresupuestos2">
                <v-list-item-icon><v-icon>mdi-domain</v-icon></v-list-item-icon>
                <v-list-item-title>Sedes</v-list-item-title>
              </v-list-item>

              <v-list-item
                to="/comisiones-instituciones"
                link
                v-if="!permisosInternacionalizacion">
                <v-list-item-icon><v-icon>mdi-bank</v-icon></v-list-item-icon>
                <v-list-item-title>Instituciones</v-list-item-title>
              </v-list-item>

              <v-list-item
                to="/comisiones-tipos-documentos-persona"
                link
                v-if="!permisosInternacionalizacion">
                <v-list-item-icon><v-icon>mdi-card-text</v-icon></v-list-item-icon>
                <v-list-item-title>Tipos Documentos Persona</v-list-item-title>
              </v-list-item>

              <v-list-item
                to="/comisiones-inscripciones-productividad"
                link
                v-if="!permisosDNA || permisosPresupuestos2">
                <v-list-item-icon><v-icon>mdi-chart-bar</v-icon></v-list-item-icon>
                <v-list-item-title>Inscripciones Productividad</v-list-item-title>
              </v-list-item>
            </v-list-group>

            <v-list-group
              v-else-if="menu.nombre == 'Dashboard'"
              :key="menu.id || 9"
              prepend-icon="mdi-chart-bar"
              no-action>
              <template v-slot:activator>
                <v-list-item-title>Dashboard</v-list-item-title>
              </template>

              <v-list-item to="/efectivos" link v-if="$store.state.CARGO.id != 26">
                <v-list-item-icon><v-icon>mdi-account-multiple</v-icon></v-list-item-icon>
                <v-list-item-title>Efectivos</v-list-item-title>
              </v-list-item>
              <v-list-item to="/xreporte" link v-if="$store.state.CARGO.id != 26">
                <v-list-item-icon><v-icon>mdi-chart-bar</v-icon></v-list-item-icon>
                <v-list-item-title>Reporte Marketing</v-list-item-title>
              </v-list-item>
              <v-list-item to="/xreporteporsede" link>
                <v-list-item-icon><v-icon>mdi-chart-line</v-icon></v-list-item-icon>
                <v-list-item-title>Reporte Mkt2</v-list-item-title>
              </v-list-item>
              <v-list-item to="/xreportec" link v-if="$store.state.CARGO.id != 26">
                <v-list-item-icon><v-icon>mdi-calendar-week</v-icon></v-list-item-icon>
                <v-list-item-title>Reporte Semanas</v-list-item-title>
              </v-list-item>
              <v-list-item to="/semaforo" link v-if="$store.state.CARGO.id != 26">
                <v-list-item-icon><v-icon>mdi-traffic-light</v-icon></v-list-item-icon>
                <v-list-item-title>Semaforo</v-list-item-title>
              </v-list-item>
              <v-list-item to="/semaforopro" link v-if="$store.state.CARGO.id != 26">
                <v-list-item-icon><v-icon>mdi-book</v-icon></v-list-item-icon>
                <v-list-item-title>Programas</v-list-item-title>
              </v-list-item>
              <v-list-item to="/semaforoins" link v-if="$store.state.CARGO.id != 26">
                <v-list-item-icon><v-icon>mdi-format-list-bulleted</v-icon></v-list-item-icon>
                <v-list-item-title>Ins. por sede</v-list-item-title>
              </v-list-item>
              <v-list-item to="/semaforosed" link v-if="$store.state.CARGO.id != 26">
                <v-list-item-icon><v-icon>mdi-domain</v-icon></v-list-item-icon>
                <v-list-item-title>Ins. por programa</v-list-item-title>
              </v-list-item>
            </v-list-group>

            <v-list-item
              v-else-if="menu.nombre != 'Dashboard'"
              :key="menu.id || 10"
              :to="menu.enlace"
              link>
              <v-list-item-icon>
                <v-icon>mdi-link</v-icon>
              </v-list-item-icon>
              <v-list-item-title>{{ menu.nombre == 'Postgrados' ? menu_name : menu.nombre }}</v-list-item-title>
            </v-list-item>
          </template>

          <v-list-item v-if="$store.state.MENUS.length == 0">
            <v-list-item-title class="text-center primary--text">{{ text_empty }}</v-list-item-title>
          </v-list-item>

          <v-list-item
            v-if="$store.state.DATA_USER.id == 1"
            :href="`http://localhost:8081/#/?token=${token}`"
            link>
            <v-list-item-icon><v-icon>mdi-school</v-icon></v-list-item-icon>
            <v-list-item-title>Academico</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-navigation-drawer>

      <div class="flex-grow-1" style="overflow: auto; padding: 16px;">
        <router-view />
      </div>
    </div>

    <AModalPreinscritos ref="amodalpreinscritos" />

    <comprobar ref="refcomprobar" v-on:success="() => {}" />

    <v-dialog width="500">
      <v-card>
        <v-card-title class="text-h5 red darken-2 white--text"> Estas en el modo pruebas </v-card-title>
        <v-card-text>
          AVISO: en este modo de pruebas todos los datos ingresados no tienen ninguna validez.
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="dialog = false"> I accept </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<style lang="css">
@import '../components/estio_principal.css';

.sidebar-drawer .v-list-item--link:before {
  display: none;
}
.sidebar-drawer .v-list-item:hover {
  background-color: rgba(0, 0, 0, 0.04);
}
.sidebar-drawer .v-list-group--sub-group .v-list-item__icon {
  margin-left: 0;
}
.sidebar-drawer .v-list-group--sub-group .v-list-item {
  padding-left: 8px !important;
}
.sidebar-drawer .v-list-group .v-list-group--sub-group .v-list-item {
  padding-left: 16px !important;
}
.sidebar-drawer .v-list-item--active:before {
  opacity: 0;
}
.sidebar-drawer .v-list-group__items .v-list-item {
  padding-left: 8px !important;
}
.sidebar-drawer.v-navigation-drawer--mini-variant .v-list-group__items {
  display: none;
}
.multiselect-custom .multiselect__tags {
  border: none;
  min-height: unset;
}
.multiselect-custom {
  min-height: unset;
}
</style>

<script lang="js">
    import gql from 'graphql-tag'
    import { mapMutations } from "vuex";
    import xaxios from '@/xaxios';
    import { getAccessToken,reloginManual } from "@/accessToken";
    import AModalPreinscritos from '@/components/AModalPreinscritos.vue';
    import {getUserData} from '@/accessToken.js';
    import {encryptToSendWebinars,encryptToSendWapito} from '@/accessToken.js';
    // import AModalConvenio from '@/components/AModalConvenioSelect.vue';
    // import registrar from './nominaciones/cajas/registrar.vue';
    import comprobar from './nominaciones/cajas/comprobar.vue';
    import { mapGetters } from 'vuex';

    export default {
      data(){
        return{
          app_name: process.env.VUE_APP_NAME,
          img_logo: process.env.VUE_APP_LOGO,
          url_client_email: process.env.VUE_APP_URL_CLIENT_EMAIL,
          location_user_pick: process.env.VUE_APP_URL_USERPICK,
          profile: "img/user-default.png",
          activado: true,
          text_empty: 'Cargando...',
          menus: [],
          convenios:[],
          usuario : {},
          me: '',
          redirect: '/'+process.env.VUE_APP_BASE_URL,
          menu_name: process.env.VUE_APP_NAME_MENU,
          isdevmode: false,
          veroferta: false,
          token: '',
          relogin_loading: false,
          is_rol_administrador: false,
          drawer: true,
          mini: false
        }
      },
      components:{AModalPreinscritos,comprobar},
      apollo: {
        me: {
          query: gql `query{ me{ datos_personales{id,sexo,num_doc,nombres,pri_apellido,seg_apellido,estado,tipo,usuario{foto,firma,correo_corp}}, cargos{ idsede, cargo{id,nombre},sede{id,nombre,unidad_negocio,subsidiaria,subsidiaria_id,ubicacion,ubicacion_id},desde,hasta } } }`,
          result ({ data }) {
            window.console.log('---------->',data?.me?.datos_personales);
            this.parseMe( data );
            this.token=getAccessToken();  // aqui
          },
        },
      },
      watch:{
        '$store.state.CARGO':function(a){
          if(a !=null ) {
            this.setCargoSedeStore(a);
            window.sessionStorage.setItem( 'XCARGO',JSON.stringify(a) );
            // window.console.log('CARGOOOO',a);
            this.getCategorias();
          }
          this.cargardata();
          // window.console.log( "CAMBIO CARGOOO ",a );
          this.parseMenus();
          this.$store.state.isonlyread = this.$store.state.CARGO.id == 22;
          //this.verificarPermisos();
        },
        'process.env.VUE_APP_GRAPHQL': function(){
          let apidev = process.env.VUE_APP_GRAPHQL;
          if( apidev.includes("apidev") ){ this.isdevmode = true; }
          else{ this.isdevmode = false; }
        },
        /*'$store.state.convenio': function(){
          this.abrirelmodalcito();
        }*/

      },
      computed: {
        ...mapGetters({
          permisosPresupuestos1: 'presupuesto/permisosPresupuestos1',
          permisosPresupuestos2: 'presupuesto/permisosPresupuestos2',
          permisosPresupuestos3: 'presupuesto/permisosPresupuestos3',
          permisosAcademicosSede: 'pago/permisosAcademicosSede',
          permisosAcademicosNacional: 'pago/permisosAcademicosNacional',
          permisosGestionEmpresarial: 'pago/permisosGestionEmpresarial',
          permisosContabilidadNacional: 'pago/permisosContabilidadNacional',
          permisosAcademicosSedeSoloLectura: 'pago/permisosAcademicosSedeSoloLectura',
          permisosInternacionalizacion: 'comision/permisosInternacionalizacion',
          permisosGerentes: 'gasto/permisosGerentes',
          permisosDNA: 'comision/permisosDNA',
          permisosResponsablesAdmisiones: 'comision/permisosResponsablesAdmisiones',
          permisosResponsablesTitulaciones: 'comision/permisosResponsablesTitulaciones',
        }),
      },
      methods:{
        ...mapMutations(['setCargoSedeStore', 'setCargosWithSedeStore']),
        salir(){
          window.localStorage.clear();
          window.sessionStorage.clear();
          this.$store.state.isLogin = false;
          //window.location.reload();
          this.activado = false;
          // window.location.href = "/portal"
          window.location.href = this.redirect
        },
        async relogin (){
          this.relogin_loading = true;
          let res = await reloginManual();
          if(res){
            this.$root.$notify.show("exito", {color:'green',x: 'right',});
          }else{
            this.$root.$notify.show("error actualice la pagina.", {color:'red',x: 'right',});
          }
          this.relogin_loading = false;
        },
        perfil(){
          window.sessionStorage.setItem( 'xperfil',JSON.stringify( this.$store.state.DATA_USER ) );
          this.$router.push({name:'perfil'});
        },
        /* abrirelmodalcito(){
          if(this.$store.state.CARGO && this.$store.state.CARGO.sede.unidad_negocio == 1 || $store.state.CARGO.sede.unidad_negocio == 10){
            if(!this.$store.state.convenio) this.$refs.amodalconvenio.openmodal();
          }
        }, */
        recibosesam( menu ){
          let enlace = menu.enlace;
          if( this.$store.state.CARGO ){
            if( this.$store.state.CARGO.sede.nombre.includes('Esam') ){
              enlace = 'recibosesam'
            }
          }
          return enlace;
        },
        openregistrarCaja(item=null){
          this.$refs.refcomprobar.openmodal(item);
        },
        parseMe( data ){
          //window.console.log('>>>>>>DATA: ',data);
          if(data?.me == null ){
            //SESION EXPIRADA, EL TOKEN YA NO ES VALIDO Y DEBE GENERARSE UNO NUEVO
            this.salir();
          }else{
            //this.abrirelmodalcito();
            // let names = data?.me?.datos_personales?.nombres+" "+data?.me?.datos_personales?.pri_apellido;
            // :) mucho molesta los pre inscritos, ademas solo sale en test
            // this.getpreinscritos(data.me?.datos_personales.id,names);
            // window.console.log('>>>>>>parseMe: ',data);
            this.$store.state.me = data?.me;
            //window.console.log(JSON.stringify(data),null,4)
            var me = data?.me;
            this.$store.state.DATA_USER = me?.datos_personales;
            if( me?.datos_personales.sexo == "F" ) this.profile= "img/user-default2.png";

            const ex = getUserData();
            this.text_empty = "Cargando...";
            if(ex){
              const parseado = JSON.parse(ex);
              const userdata = this.$store.state.DATA_USER;
              if( (parseado.clave+'').startsWith(userdata.num_doc) ){
                this.text_empty = "";

                this.$store.state.CARGO = {sede:{},cargo:{}};
                this.$router.push("/perfilchange");

                setTimeout(() => {
                  const n = document.getElementById('navbar-primary-na');
                  if(n){
                    const isColl = n.classList.contains('collapsed');
                    if(!isColl) n.classList.add('collapsed');
                    else n.classList.remove('collapsed');
                  }
                }, 300);

              }else{
                this.getdatadata(me);
              }
            }else{
              this.getdatadata(me);
            }


          }
        },
        getdatadata(me){
          try {
              var user = me?.datos_personales?.usuario;
              if( user ){
                var foto = user.foto;
                if( foto && foto.includes('.') ) this.profile= this.location_user_pick+foto;
              }
            } catch (error) {
              window.console.error( error );
            }
            this.$store.state.CARGO = me.cargos[0];
            this.parseCargos();
            this.getGestiones();
            this.getCategorias();
            this.getSedes();
            this.eventomobile();
            this.getConveniosUniversidades();
        },

        getpreinscritos(idasesor,names){
          const vue = this;
          let url = `${process.env.VUE_APP_API_REST}/api/v1/asesores/publico/preinscritos/${idasesor}`;
          //let url = `http://localhost:8090/api/v1/asesores/publico/preinscritos/${idasesor}`;
          var config = {
            method: 'get',
            url: url,
          };

          xaxios.request(config)
          .then(function (response) {
            //if( !response.data ) response.data = {data:[]};
            let datos = response.data.data;
            //window.console.log('getpreinscritos>>>>',datos);
            if(vue.$refs.amodalpreinscritos) vue.$refs.amodalpreinscritos.openmodal(datos,names)
          })
          .catch(function (error) {
            window.console.log('>>>',error);
          });
        },
        parseMenus(){
          // window.console.log('this.$store.state.CARGO',this.$store.state.CARGO);
          var vue = this;
          this.$store.state.MENUS=[];
          if( this.$store.state.CARGO == null ){ window.console.error( "CARGO NULO" ); return; }
          let cid = this.$store.state.CARGO.id;
          this.is_rol_administrador = cid == 4 || cid == 22;
          let sedeid = this.$store.state.CARGO.sede.id;
          // let unidad_negocio = this.$store.state.CARGO.sede.unidad_negocio;
          if(cid==27){
            vue.$store.state.MENUS.push( {id:-3,nombre:'Facturas',enlace:'-1',icono:'',visualizar:true} )
            vue.$store.state.MENUS.push( {id:-6,nombre:'Tesorería',enlace:'-1',icono:'',visualizar:true} )
          }
          else if(cid == 26) {
            vue.$store.state.MENUS.push( {id:-1,nombre:'Mis inscripciones',enlace:'-1',icono:'',visualizar:true} )
            vue.$store.state.MENUS.push( {id:-2,nombre:'Postgrados',enlace:'-1',icono:'',visualizar:true} )
            vue.$store.state.MENUS.push( {id:-3,nombre:'Facturas',enlace:'-1',icono:'',visualizar:true} )
            vue.$store.state.MENUS.push( {id:-4,nombre:'Dashboard',enlace:'-1',icono:'',visualizar:true} )
            vue.$store.state.MENUS.push( {id:-5,nombre:'Presupuesto',enlace:'-1',icono:'',visualizar:true} )
            vue.$store.state.MENUS.push( {id:-6,nombre:'Tesorería',enlace:'-1',icono:'',visualizar:true} )
            vue.$store.state.MENUS.push( {id:-7,nombre: 'Pago',enlace:'-1',icono:'',visualizar:true} )
            vue.$store.state.MENUS.push( {id:-8,nombre:'Comision',enlace:'-1',icono:'',visualizar:true} )
            vue.$store.state.MENUS.push( {id:-9,nombre:'Planificador',enlace:'-1',icono:'',visualizar:true} )
            // vue.$store.state.MENUS.push( {id:-10,nombre:'Gastos',enlace:'-1',icono:'',visualizar:true} )
          }else if(cid != 24 && cid != 26){
            vue.$store.state.MENUS.push( {id:-1,nombre:'Cargos',enlace:'-1',icono:'',visualizar:true} )
            vue.$store.state.MENUS.push( {id:-2,nombre:'Mis inscripciones',enlace:'-1',icono:'',visualizar:true} )
            vue.$store.state.MENUS.push( {id:-3,nombre:'Postgrados',enlace:'-1',icono:'',visualizar:true} )
            vue.$store.state.MENUS.push( {id:-4,nombre:'Facturas',enlace:'-1',icono:'',visualizar:true} )
            vue.$store.state.MENUS.push( {id:-5,nombre:'Dashboard',enlace:'-1',icono:'',visualizar:true} )
            vue.$store.state.MENUS.push( {id:-6,nombre:'Planificador',enlace:'-1',icono:'',visualizar:true} )
            vue.$store.state.MENUS.push( {id:-7,nombre:'Presupuesto',enlace:'-1',icono:'',visualizar:true} )
            vue.$store.state.MENUS.push( {id:-8,nombre:'Tesorería',enlace:'-1',icono:'',visualizar:true} )
            vue.$store.state.MENUS.push( {id:-9,nombre: 'Pago',enlace:'-1',icono:'',visualizar:true} )
            vue.$store.state.MENUS.push( {id:-10,nombre:'Comision',enlace:'-1',icono:'',visualizar:true} )
            // vue.$store.state.MENUS.push( {id:-11,nombre:'Gastos',enlace:'-1',icono:'',visualizar:true} )
          }else if(sedeid == 34 || sedeid == 35 || sedeid == 36) {
            vue.$store.state.MENUS.push( {id:-1,nombre:'Planificador',enlace:'-1',icono:'',visualizar:true} )
            vue.$store.state.MENUS.push( {id:-2,nombre:'Presupuesto',enlace:'-1',icono:'',visualizar:true} )
            vue.$store.state.MENUS.push( {id:-3,nombre:'Tesorería',enlace:'-1',icono:'',visualizar:true} )
            vue.$store.state.MENUS.push( {id:-4,nombre: 'Pago',enlace:'-1',icono:'',visualizar:true} )
            vue.$store.state.MENUS.push( {id:-5,nombre:'Comision',enlace:'-1',icono:'',visualizar:true} )
            // vue.$store.state.MENUS.push( {id:-6,nombre:'Gastos',enlace:'-1',icono:'',visualizar:true} )
          }else{
            vue.$store.state.MENUS.push( {id:-1,nombre:'Postgrados',enlace:'-1',icono:'',visualizar:true} )
            vue.$store.state.MENUS.push( {id:-2,nombre:'Planificador',enlace:'-1',icono:'',visualizar:true} )
            vue.$store.state.MENUS.push( {id:-3,nombre:'Presupuesto',enlace:'-1',icono:'',visualizar:true} )
            vue.$store.state.MENUS.push( {id:-4,nombre:'Tesorería',enlace:'-1',icono:'',visualizar:true} )
            vue.$store.state.MENUS.push( {id:-5,nombre: 'Pago',enlace:'-1',icono:'',visualizar:true} )
            vue.$store.state.MENUS.push( {id:-6,nombre:'Comision',enlace:'-1',icono:'',visualizar:true} )
            // vue.$store.state.MENUS.push( {id:-7,nombre:'Gastos',enlace:'-1',icono:'',visualizar:true} )
          }

          const uid = this.$store.state.DATA_USER.id;
          this.veroferta = (cid == 1 || cid == 2 || cid == 3 || cid == 5 || cid == 13 || cid == 12 || cid == 26 || uid == 35886 || uid==59716 || uid == 11 || uid == 12 || uid == 13) || ((cid == 5 || cid == 6 || cid == 7 || cid == 11 || uid==9029) /* && this.isdevmode */ )


        },
        parseCargos(){
          var vue = this;
          this.$store.state.me.cargos.forEach( function(e){
            if( !e.sede ) e.sede = {};
            var ca = e.cargo.nombre;
            var se = e.sede.nombre;
            vue.$store.state.CARGOS.push({ id:e.cargo.id, idsede:e.sede.id, nombre:se+" - "+ca, cargo:e.cargo, sede:e.sede })
          });
          this.$store.state.CARGO = vue.$store.state.CARGOS[0];
          this.setCargosWithSedeStore(this.$store.state.CARGOS);
          this.setCargoSedeStore(this.$store.state.CARGO)
        },
        getGestiones() {
          this.$apollo.query({ query: gql`query{getGestiones{gestion,apertura,cierre}}` })
            .then(({ data: { getGestiones } }) => {
              const data = getGestiones.reverse()
              let anio = new Date().getFullYear();
              let existe = getGestiones.find(x=>x.gestion==anio);
              this.$store.dispatch("gestion/setGestiones", data);
              this.$store.dispatch("gestion/addGestion", {gestion:'todos'});
              this.$store.dispatch("gestion/selectGestion", data.length ? existe :null);
            })
            .catch((error) => {window.console.error(error)});
        },
        getCategorias() {
          let unidad_negocio = this.$store.state.CARGO.sede.unidad_negocio;
          this.$apollo.query({ query: gql`query { getCategorias(unidad_negocio_id:${unidad_negocio}) {id nombre descripcion estado unidad_negocio_id clase_netsuite_id }}` })
            .then(({ data: { getCategorias } }) => {
              // window.console.log('getCategorias',getCategorias);
              this.$store.dispatch("categoria/setCategorias",getCategorias );
            }).catch(() => []);
        },
        getSedes() {
          const qs = gql` query {getSedes ${''} {id, nombre,unidad_negocio, direccion, telefono1, telefono2, telefono_fijo, latitud, longitud, modelo_recibo, aulas {id},subsidiaria,subsidiaria_id,ubicacion,ubicacion_id, ciudad{ id, nombre, departamento {nombre}}}}`;
          this.$apollo.query({ query: qs })
            .then(({ data: { getSedes } }) => {
              this.$store.dispatch("modsede/setSedes",getSedes.length ? getSedes:[] );
            }).catch(() => []);
        },
        resize(){
          var x = window.screen.width;
          if( x <= 456 ){
            var n = document.getElementById('navbar-primary-na');
            if( !n ) return
            var isColl = n.classList.contains('collapsed');
            if(!isColl) n.classList.add('collapsed');
          }
        },
        /*parseMenusProduccion(){
          let iduser = this.$store.state?.me?.datos_personales?.id;
          let excepcion_permitir_gen_recibos = iduser == 1331; // Carmen julia de camargo es academica y parte contable
          if( excepcion_permitir_gen_recibos ){
            let menucito = {
              enlace: "/recibosesam",
              icono: "glyphicon glyphicon-credit-card",
              id: 360,
              nombre: "Recibos",
              visualizar: true,
            };
            this.$store.state.MENUS.push( menucito );
          }
          let aprobar_descuentos = this.$store.state.CARGO.id == 1 || this.$store.state.CARGO.id == 14 || this.$store.state.CARGO.id == 18;
          let ver_facturas = this.$store.state.CARGO.id == 1 || this.$store.state.CARGO.id == 14 || this.$store.state.CARGO.id == 15 || this.$store.state.CARGO.id == 25 || this.$store.state.CARGO.id == 18;
          // window.console.log( 'aprobar_descuentos',aprobar_descuentos );
          if( aprobar_descuentos ){
            this.$store.state.MENUS.push( {id:-20,nombre:'Descuentos',enlace:'/descuentoslista',icono:'glyphicon glyphicon-inbox',visualizar:true} )
          }
          if( ver_facturas ){
            this.$store.state.MENUS.push( {id:-21,nombre:'Facturas',enlace:'/facturaslista',icono:'glyphicon glyphicon-copy',visualizar:true} )
          }
          // window.console.log( this.$store.state.MENUS,excepcion_permitir_gen_recibos  );
          // window.console.log('this.$store.state::::',this.$store.state)

          this.$store.state.MENUS = this.$store.state.MENUS.filter( function(e){
            if( e.nombre == "Mis inscripciones" ) return true;
            else if( e.nombre == "Postgrados" ) return true;
            else if( e.nombre == "Cargos" ) return true;
            else if( e.nombre == "Semaforo" ) return true;
            else if( e.nombre == "Facturas" ) return true;
            else if( e.nombre == "Dashboard" ) return true;
            else if( e.nombre == "Presupuesto" ) return true;
            else if( e.nombre == "Tesorería" ) return true;
            else if( e.nombre == "Pago" ) return true;
            else if( e.nombre == "Comision" ) return true;
            return false;
          })
        },*/
        cargardata() {
            let unidad_negocio = 1;
            if( this.$store.state.CARGO ){
              unidad_negocio = this.$store.state.CARGO.sede.unidad_negocio;
            }
            // window.console.log('unidad_negocio:::',unidad_negocio)
            if (unidad_negocio == 1) {
              this.$store.state.unidad.mision = process.env.VUE_APP_MISION_ESAM;
              this.$store.state.unidad.vision = process.env.VUE_APP_VISION_ESAM;
              this.$store.state.unidad.about = '';
              this.$store.state.unidad.logo = process.env.VUE_APP_LOGO_ESAM;
              this.$store.state.unidad.postgrados = 'Postgrados';
              this.$store.state.unidad.programas = 'Programas';
            } else if (unidad_negocio == 2 || unidad_negocio == 12) {
              this.$store.state.unidad.mision = process.env.VUE_APP_MISION_CCA;
              this.$store.state.unidad.vision = process.env.VUE_APP_VISION_CCA;
              this.$store.state.unidad.about = '';
              this.$store.state.unidad.logo = process.env.VUE_APP_LOGO_CCA;
              this.$store.state.unidad.postgrados = 'Carreras';
              this.$store.state.unidad.programas = 'Cursos';
            } else if (unidad_negocio == 3) {
              this.$store.state.unidad.mision = process.env.VUE_APP_MISION_CK;
              this.$store.state.unidad.vision = process.env.VUE_APP_VISION_CK;
              this.$store.state.unidad.about = '';
              this.$store.state.unidad.logo = process.env.VUE_APP_LOGO_CK;
              this.$store.state.unidad.postgrados = 'Carreras';
              this.$store.state.unidad.programas = 'Cursos';
            } else if (unidad_negocio == 4) {
              this.$store.state.unidad.mision = process.env.VUE_APP_MISION_CAS;
              this.$store.state.unidad.vision = process.env.VUE_APP_VISION_CAS;
              this.$store.state.unidad.about = '';
              this.$store.state.unidad.logo = process.env.VUE_APP_LOGO_CAS;
              this.$store.state.unidad.postgrados = 'Niveles';
              this.$store.state.unidad.programas = 'Cursos Cas';
            } else {
              this.$store.state.unidad.postgrados = 'Postgrados';
              this.$store.state.unidad.programas = 'Programas';
            }
            //window.console.log(this.$store.state.CARGO.sede);
            //
          },
        eventomobile(){
          const d = document.getElementById('btn-expand-hi');
          if(d){
            d.addEventListener("click", function(){
              const n = document.getElementById('navbar-primary-na');
              if(n){
                const isColl = n.classList.contains('collapsed');
                if(!isColl) n.classList.add('collapsed');
                else n.classList.remove('collapsed');
              }
            });
          }
        },

        async getConveniosUniversidades() {
          const sql = gql`query{ getInstituciones(estado:true){id,nombre,tipo,convenio,abreviatura} }`;
          this.$apollo.query({ query: sql }).then(({ data }) => {
            let conves = data.getInstituciones;
            conves = conves.filter(x=>{return x.convenio});
            this.convenios = conves;
          });
        },

        irAWebinars(){
          const unidad = this.$store.state.CARGO.sede.unidad_negocio;
          // window.console.log(unidad);
          if(unidad != 1 && unidad != 10 && unidad != 5 && unidad != 15 ) {
            this.$root.$notify.show(`No disponible para esta unidad de negocio`, {color:'green',x: 'left',});
            return;
          }
          encryptToSendWebinars(this);
        },
        irAWapito(){
          encryptToSendWapito();
        },
        irPortal2(){
          const host = process.env.VUE_APP_PORTAL2_APP;
          const us = getUserData();
          const d = JSON.stringify(us);
          let encodedData = btoa(d);
          // const host = 'http://localhost:9200'
          const url = host+'?token='+getAccessToken()+'&d='+encodedData;
          window.open(url);
        },
        toggleMini(){
          this.mini = !this.mini;
        }
      },
      mounted(){
        // this.$store.state.DATA_USER = {};
        // this.$store.state.CARGO = {sede:{}};
        let apidev = process.env.VUE_APP_GRAPHQL;
        // window.console.log('apidev:::::><>>',apidev);
        if( apidev.includes("apidev") ){ this.isdevmode = true; }
        else{ this.isdevmode = false; }
        this.cargardata();

        // var url = window.location.href;
        // var slack = url.lastIndexOf('/')
        // if( slack > 0 ) url = url.substring( slack )
        // this.$router.push( url )
      }
    }
  </script>
